import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormSetting extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    setting: PropTypes.object,

    createSetting: PropTypes.func,
    updateSetting: PropTypes.func,
    deleteSetting: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      description: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.setting);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(setting) {
    this.setState({
      loading: false,
      companyName: setting ? setting.companyName : "",
      taxNumber: setting ? setting.taxNumber : "",
      address1: setting ? setting.address1 : "",
      address2: setting ? setting.address2 : "",
      city: setting ? setting.city : "",
      zip: setting ? setting.zip : "",
      state: setting ? setting.state : "",
      logoLarge: setting ? setting.logoLarge : "",
      logoSmall: setting ? setting.logoSmall : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this setting, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteSetting, close, refresh, setting } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteSetting(setting.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Setting has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateSetting,
      createSetting,
      setting,
      refresh,
      close,
    } = this.props;

    const {
      companyName,
      taxNumber,
      address1,
      address2,
      city,
      zip,
      state,
      logoLarge,
      logoSmall,
    } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (setting) {
      resp = await updateSetting(setting.id, {
        companyName,
        taxNumber,
        address1,
        address2,
        city,
        zip,
        state,
        logoLarge,
        logoSmall,
      });
    } else {
      resp = await createSetting({
        companyName,
        taxNumber,
        address1,
        address2,
        city,
        zip,
        state,
        logoLarge,
        logoSmall,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: setting
          ? "Setting has been updated."
          : "Setting has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, setting, close } = this.props;

    const {
      companyName,
      taxNumber,
      address1,
      address2,
      city,
      zip,
      state,
      logoLarge,
      logoSmall,
      loading,
    } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {setting
                ? `${setting.companyName}`
                : "Let's Create a New Setting"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {setting
                  ? "To update the setting, fill the form below :"
                  : "To create a new setting, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Company Name"
                    className={classes.textField}
                    value={companyName}
                    onChange={this.handleChange("companyName")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="taxNumber"
                    label="Tax Number"
                    className={classes.textField}
                    value={taxNumber}
                    onChange={this.handleChange("taxNumber")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="address1"
                    label="Address line 1"
                    className={classes.textField}
                    value={address1}
                    onChange={this.handleChange("address1")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="address2"
                    label="Address line 2"
                    className={classes.textField}
                    value={address2}
                    onChange={this.handleChange("address2")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="zip"
                    label="Zip"
                    className={classes.textField}
                    value={zip}
                    onChange={this.handleChange("zip")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="city"
                    label="City"
                    className={classes.textField}
                    value={city}
                    onChange={this.handleChange("city")}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    id="state"
                    label="State"
                    className={classes.textField}
                    value={state}
                    onChange={this.handleChange("state")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="logoLarge"
                    label="Logo Large (coloured)"
                    className={classes.textField}
                    value={logoLarge}
                    onChange={this.handleChange("logoLarge")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="logoSmall"
                    label="Logo Small (white)"
                    className={classes.textField}
                    value={logoSmall}
                    onChange={this.handleChange("logoSmall")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {setting && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {setting ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormSetting));
